/* unplugin-vue-components disabled */import { render } from "./copy-tooltip.vue?vue&type=template&id=db94274a"
import script from "./copy-tooltip.vue?vue&type=script&lang=js"
export * from "./copy-tooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/copy-tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db94274a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db94274a', __exports__)) {
    api.reload('db94274a', __exports__)
  }
  
  module.hot.accept("./copy-tooltip.vue?vue&type=template&id=db94274a", () => {
    api.rerender('db94274a', render)
  })

}


export default __exports__